import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Buildings, MapPin, PencilSimple, House, Factory, Tree, Storefront, Lightning, Gauge } from '@phosphor-icons/react';

export function ImmobileSection({ immobile, onEdit }) {
    const tipologiaIcons = {
        residenziale: House,
        commerciale: Storefront,
        industriale: Factory,
        agricolo: Tree
    };
    const TipologiaIcon = tipologiaIcons[immobile?.tipologia] || Buildings;

    return (
        <Card>
            <CardHeader className="pb-3">
                <div className="flex items-center justify-between">
                    <CardTitle className="flex items-center gap-2 text-base">
                        <Buildings className="w-5 h-5 text-primary" />
                        Dati Immobile
                        {immobile?.tipologia && (
                            <Badge variant="outline" className="ml-2 capitalize">
                                <TipologiaIcon className="w-3 h-3 mr-1" />
                                {immobile.tipologia}
                            </Badge>
                        )}
                    </CardTitle>
                    <Button variant="ghost" size="sm" onClick={onEdit} data-testid="edit-immobile-btn">
                        <PencilSimple className="w-4 h-4" />
                    </Button>
                </div>
            </CardHeader>
            <CardContent className="space-y-4">
                {/* Indirizzo */}
                <div>
                    <p className="text-xs text-muted-foreground flex items-center gap-1">
                        <MapPin className="w-3 h-3" /> Indirizzo Sito
                    </p>
                    {immobile?.indirizzo ? (
                        <p className="text-sm">
                            {immobile.indirizzo}{immobile.civico && `, ${immobile.civico}`}
                            {immobile.comune && `, ${immobile.comune}`}
                            {immobile.cap && ` ${immobile.cap}`}
                            {immobile.provincia && ` (${immobile.provincia})`}
                        </p>
                    ) : (
                        <p className="text-sm text-muted-foreground">Non specificato</p>
                    )}
                </div>

                {/* Dati Catastali */}
                {(immobile?.foglio || immobile?.particella) && (
                    <div className="p-3 bg-muted/50 rounded-lg">
                        <p className="text-xs text-muted-foreground mb-2">Dati Catastali</p>
                        <div className="grid grid-cols-3 gap-2 text-sm">
                            <div>
                                <span className="text-muted-foreground">Foglio:</span> {immobile.foglio || '-'}
                            </div>
                            <div>
                                <span className="text-muted-foreground">Particella:</span> {immobile.particella || '-'}
                            </div>
                            <div>
                                <span className="text-muted-foreground">Sub:</span> {immobile.subalterno || '-'}
                            </div>
                        </div>
                    </div>
                )}

                {/* Coordinate GPS */}
                {(immobile?.latitudine || immobile?.longitudine) && (
                    <div>
                        <p className="text-xs text-muted-foreground">Coordinate GPS</p>
                        <p className="text-sm font-mono">
                            {immobile.latitudine?.toFixed(6)}, {immobile.longitudine?.toFixed(6)}
                        </p>
                    </div>
                )}

                {/* Proprietario diverso */}
                {immobile?.proprietario_diverso && immobile?.proprietario_nome && (
                    <div className="p-3 bg-amber-50 dark:bg-amber-950/30 rounded-lg border border-amber-200 dark:border-amber-800">
                        <p className="text-xs text-amber-700 dark:text-amber-400 mb-1">Proprietario Immobile (diverso dal cliente)</p>
                        <p className="text-sm font-medium">
                            {immobile.proprietario_nome} {immobile.proprietario_cognome}
                        </p>
                        {immobile.proprietario_codice_fiscale && (
                            <p className="text-xs font-mono">{immobile.proprietario_codice_fiscale}</p>
                        )}
                    </div>
                )}

                {/* POD e Potenza */}
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <p className="text-xs text-muted-foreground flex items-center gap-1">
                            <Lightning className="w-3 h-3" /> POD
                        </p>
                        <p className="text-sm font-mono">{immobile?.pod || '-'}</p>
                    </div>
                    <div>
                        <p className="text-xs text-muted-foreground flex items-center gap-1">
                            <Gauge className="w-3 h-3" /> Potenza Contatore
                        </p>
                        <p className="text-sm">{immobile?.potenza_contatore_kw ? `${immobile.potenza_contatore_kw} kW` : '-'}</p>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}
